import { useState } from "react";
import AdInquiryDialog from "components/main/ad_inquiry_dialog";

/**
 * 배너 광고 슬롯.
 * - 실제 광고가 들어오기 전엔 플레이스홀더(광고 문의 CTA) 표시
 * - 배포 시 ads={[{imageUrl, linkUrl, alt}, ...]} 형태로 내려주면 캐러셀 동작
 * - 사용자가 닫기(X)를 누르면 세션 동안 숨김
 */
export default function AdBannerSlot({ ads = [] }) {
  const [index, setIndex] = useState(0);
  const [inquiryOpen, setInquiryOpen] = useState(false);

  const hasAds = ads.length > 0;
  const current = hasAds ? ads[index] : null;

  const handleClick = () => {
    if (current?.linkUrl) window.open(current.linkUrl, "_blank", "noopener");
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: 1200,
        margin: "0 auto 24px",
        padding: "0 24px",
      }}
    >
      <div
        onClick={hasAds ? handleClick : undefined}
        role={hasAds ? "link" : undefined}
        style={{
          position: "relative",
          width: "100%",
          minHeight: 120,
          borderRadius: 16,
          overflow: "hidden",
          background: hasAds
            ? "#F3F4F6"
            : "linear-gradient(135deg, #FEF3C7 0%, #FDE68A 50%, #FCD34D 100%)",
          border: "1px solid #E5E7EB",
          cursor: hasAds ? "pointer" : "default",
          display: "flex",
          alignItems: "center",
        }}
      >
        {hasAds ? (
          <img
            src={current.imageUrl}
            alt={current.alt || "광고"}
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        ) : (
          <PlaceholderContent onInquire={() => setInquiryOpen(true)} />
        )}

        {/* 광고 라벨 */}
        <span
          style={{
            position: "absolute",
            top: 10,
            left: 12,
            padding: "3px 8px",
            borderRadius: 6,
            background: "rgba(17, 24, 39, 0.7)",
            color: "#fff",
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: "0.02em",
          }}
        >
          AD
        </span>

        {/* 캐러셀 인디케이터 */}
        {hasAds && ads.length > 1 && (
          <div
            style={{
              position: "absolute",
              bottom: 10,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: 6,
            }}
          >
            {ads.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIndex(i);
                }}
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: 9999,
                  background: i === index ? "#047857" : "rgba(255, 255, 255, 0.7)",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
                aria-label={`배너 ${i + 1}로 이동`}
              />
            ))}
          </div>
        )}
      </div>
      <AdInquiryDialog open={inquiryOpen} onClose={() => setInquiryOpen(false)} />
    </div>
  );
}

function PlaceholderContent({ onInquire }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        padding: "24px 28px",
        width: "100%",
        flexWrap: "wrap",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1, minWidth: 220 }}>
        <div style={{ fontSize: 13, color: "#92400E", fontWeight: 600, letterSpacing: "0.02em" }}>
          광고 모집 중
        </div>
        <div style={{ fontSize: 18, color: "#111827", fontWeight: 800, letterSpacing: "-0.01em" }}>
          이 자리, 당신의 브랜드를 뚝딱이 농가에게 노출하세요
        </div>
        <div style={{ fontSize: 13, color: "#4B5563" }}>
          농기계 · 비료 · 보험 등 관련 업종 우대
        </div>
      </div>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onInquire?.();
        }}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "10px 18px",
          background: "#111827",
          color: "#fff",
          border: "none",
          borderRadius: 10,
          fontSize: 14,
          fontWeight: 700,
          whiteSpace: "nowrap",
          cursor: "pointer",
        }}
      >
        광고 문의 →
      </button>
    </div>
  );
}
